import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { XSightChartColors } from '../../../../../../../assets/theme/colors.theme';

export interface Toast {
    message: string;
    type: number;
    showTime?: number; /* in msec */
}

export const enum ToastTypeIndex {
    success = 0,
    info = 1,
    warning = 2,
    error = 3
}

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    animations: [
        trigger('openCloseAnimation', [
            state('open', style({ transform: 'translateY(0)' })),
            state('closed', style({ transform: 'translateY(-100%)', display: 'none' })),
            transition('open => closed, closed => open', [
                animate(100)
            ])
        ])
    ]
})
export class ToastComponent implements OnChanges {

    @Input() toast: Toast;

    public currentToast: Toast;
    private showBar = false;
    private messageUnderProcess = false;
    private toastMessagesList: Toast[] = [];
    constructor() { }

    ngOnChanges(changes: SimpleChanges) {
        if (this.toast && changes && changes.toast.currentValue !== changes.toast.previousValue) {
            this.toastMessagesList.push(changes.toast.currentValue);
            if (!this.messageUnderProcess) {
                this.processMessage();
            }
        }
    }

    public openCloseAnimationTrigger = (): string => this.showBar ? 'open' : 'closed';

    public getBackgroundColor = (): string => {
        if (this.currentToast) {
            switch (this.currentToast.type) {
                case ToastTypeIndex.success:
                    return XSightChartColors.getColor('--toast-banner-success-bg-color');
                case ToastTypeIndex.info:
                    return XSightChartColors.getColor('--toast-banner-info-bg-color');
                case ToastTypeIndex.warning:
                    return XSightChartColors.getColor('--toast-banner-warning-bg-color');
                case ToastTypeIndex.error:
                    return XSightChartColors.getColor('--toast-banner-error-bg-color');
            }
        }
        return '#FFF';
    };

    public getIcon = (): string => {
        if (this.currentToast) {
            switch (this.currentToast.type) {
                case ToastTypeIndex.success:
                    return 'hd-icon-selected';
                case ToastTypeIndex.info:
                    return 'hd-icon-inforound';
                case ToastTypeIndex.warning:
                    return 'hd-icon-warning';
                case ToastTypeIndex.error:
                    return 'hd-icon-error';
            }
        }
        return '';
    };

    public getIconColor = (): string => {
        if (this.currentToast) {
            switch (this.currentToast.type) {
                case ToastTypeIndex.success:
                    return XSightChartColors.getColor('--toast-banner-success-icon-color');
                case ToastTypeIndex.info:
                    return XSightChartColors.getColor('--toast-banner-info-icon-color');
                case ToastTypeIndex.warning:
                    return XSightChartColors.getColor('--toast-banner-warning-icon-color');
                case ToastTypeIndex.error:
                    return XSightChartColors.getColor('--toast-banner-error-icon-color');
            }
        }
        return '#000';
    };

    private showToastMessage = (toast) => {
        this.currentToast = toast;
        this.showBar = true;
    };

    private processMessage = () => {
        this.messageUnderProcess = true;
        const nextMessage = this.getNextMessage();

        if (!nextMessage) {
            this.messageUnderProcess = false;
            return;
        }

        this.showToastMessage(nextMessage);

        // Show all the toast messages available in list one after another with 3000 ms delay.
        setTimeout(() => {
            this.showBar = false;
            this.processMessage();
        }, this.toast.showTime || 3000);
    };

    private getNextMessage(): Toast | undefined {
        return this.toastMessagesList.length ? this.toastMessagesList.shift() : undefined;
    }
}
